<div class="modal-header" id="equipment-configuration-service-key-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_TITLE"></h3>
    <span class="close" (click)="!isLoading && modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="equipmentServiceKeyForm">
        <fieldset formArrayName="formChildren" [disabled]="isLoading">
            <ng-container *ngIf="displayUSFields; else displayDefaultFields">
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-form-label text-start text-sm-end"
                        for="equipmentNo"
                        translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_EQUIPMENT_ID"
                    ></label>
                    <div class="col-sm-6">
                        <pace-core-text-input
                            id="equipmentNo"
                            [(model)]="model.equipmentNo"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_EQUIPMENT_ID' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-container>
            <ng-template #displayDefaultFields>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-form-label text-start text-sm-end"
                        for="materialNo"
                        translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_MATERIAL_ID"
                    ></label>
                    <div class="col-sm-6">
                        <pace-core-text-input
                            id="materialNo"
                            [(model)]="model.materialNo"
                            (valueChange)="resetRequiredOption()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_MATERIAL_ID' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-form-label text-start text-sm-end"
                        for="serialNo"
                        translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_SERIAL_NO"
                    ></label>
                    <div class="col-sm-6">
                        <pace-core-text-input
                            id="serialNo"
                            [(model)]="model.serialNo"
                            (valueChange)="resetRequiredOption()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_SERIAL_NO' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
                <div class="row mb-3">
                    <label
                        class="col-sm-4 col-form-label text-start text-sm-end"
                        for="hwID"
                        translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_HW_ID"
                    ></label>
                    <div class="col-sm-6">
                        <pace-core-text-input
                            id="hwID"
                            [(model)]="model.hwid"
                            (valueChange)="resetRequiredOption()"
                            [parentForm]="formChildren"
                            [ariaLabel]="'NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_HW_ID' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-template>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <progressbar *ngIf="isLoading" [striped]="true" [value]="100" type="default">Loading...</progressbar>
    <button
        *ngIf="!isLoading"
        [disabled]="equipmentServiceKeyForm.invalid"
        class="btn btn-primary"
        type="button"
        (click)="getServiceKey()"
        translate="NOTIFICATION_DETAIL_EQUIPMENTS_SERVICE_KEY_GET_KEY"
    ></button>
</div>
